module.exports = __webpack_public_path__ + "img/wx-system.0b17b375.png";